const GOVUKFrontend = require('govuk-frontend')
GOVUKFrontend.initAll()
